<template>

         <w-tabs :items="tabs" :no-slider="false" active-class="primary" v-model="activeTab">
            <template #item-content.1>
               <w-card title-class="blue-dark4--bg white" style="font-size: 13px;"  :title="'MAKLUMAT TERNAKAN'" >
                  <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
                  <template #title>
                        MAKLUMAT TERNAKAN
                        <w-flex justify-end class="mt2">
                           <w-button @click="isMinimizedList = !isMinimizedList">
                              <template v-if="isMinimizedList">
                                 <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                              </template>
                              <template v-else>
                                 <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                              </template>
                           </w-button>
                        </w-flex>
                     </template>
                  <div v-show="!isMinimizedList">
                  <div class="w-table-wrap" style="max-height: 400px;">
                     <div class="table-profil-scrol">
                        <table class="w-table" color="light" >
                           <thead>
                              <tr>
                                 <th class="w-table__header  text-center" width="1%">BIL</th>
                                 <th class="w-table__header  text-center">ID | NAMA TERNAKAN</th>
                                 <th class="w-table__header  text-center">PEMERIKSAAN RESIPIEN</th>
                                 <th class="w-table__header  text-center">PROSEDUR ET</th>
                                 <th class="w-table__header  text-center">PEMERIKSAAN KEBUNTINGAN</th>
                                 <th class="w-table__header  text-center">CETAK</th>
                                 <template v-if="data.lkp_status_id==39">
                                    <th class="w-table__header  text-center">TINDAKAN</th>
                                 </template>
                              </tr>
                           </thead>
                           <tbody>
                              <template v-for="(dt, ind) in data.ternakan_list">
                                 <tr class="w-table__row" >
                                    <td class="w-table__cell text-left" >{{ind+1}}</td>
                                    <td class="w-table__cell text-left" ><div style="width:200px"></div>
                                    <a @click="detail(dt, 0)" style="text-decoration: underline;color: #3a3ad0;">{{dt.ternakan_nama}}</a></td>
                                    <td align="center">
                                       <template v-if="data.tarikh_pemeriksaan != null">
                                       <a @click="detail(dt, 1)" style="text-decoration: underline;color: #3a3ad0;">{{$zutil.dateformat(data.tarikh_pemeriksaan)}}</a>
                                       </template>
                                       <template v-else>-</template>
                                    </td>
                                    <td align="center">
                                       <template v-if="data.tarikh_ai != null">
                                       <a @click="detail(dt, 2)" style="text-decoration: underline;color: #3a3ad0;">{{$zutil.dateformat(data.tarikh_ai)}}</a>
                                       </template>
                                       <template v-else>-</template>
                                    </td>
                                    <td align="center">
                                       <template v-if="data.tarikh_pemeriksaan_art != null">
                                          <a @click="detail(dt, 3)" style="text-decoration: underline;color: #3a3ad0;">{{$zutil.dateformat(data.tarikh_pemeriksaan_art)}}</a>
                                       </template>
                                       <template v-else>-</template>
                                    </td>
                                    <td align="center">
                                     <!--  <template v-if="datas.lkp_status_id == 18 && datas.lkp_status_id == 39 && datas.lkp_status_id == 40"> -->
                                        <w-tooltip md top color="white" bg-color="black">
                                          <template #activator="{ on }">
                                             <w-button class="ma1" v-on="on" bg-color="success" @click="cetak(dt.id)"><div style="width: 4px"></div> 
                                                <w-icon class="mr1" md style="color: white;">fal fa-print</w-icon>
                                             </w-button>
                                          </template>
                                          Cetak
                                       </w-tooltip>
                                     <!--  </template>
                                      <template v-else>-</template> -->
                                    </td>
                                    <template v-if="data.lkp_status_id==39">
                                       <td class="w-table__cell text-center"><div class="title4 mb2"></div><w-checkbox v-model="dt.pilih" :disabled="dt.lkp_status_id==28||dt.bunting==1"></w-checkbox></td>
                                    </template>
                                 </tr>
                              </template>
                           </tbody>
                        </table>
                     </div>
                  </div>
                  </div>
                  <w-flex class="mt3" wrap align-center justify-end v-if="data.lkp_status_id==39">
                     <w-button class="my1" type="submit" :disabled="loading" :loading="loading">
                         <w-icon xs class="mr2">fal fa-paper-plane</w-icon> Mohon Semula ET
                     </w-button>
                  </w-flex>
                  </w-form>
               </w-card>
               <br>
               <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'CAJ PERKHIDMATAN ET'" >
                     <template #title>
                        CAJ PERKHIDMATAN ET
                        <w-flex justify-end class="mt2">
                           <w-button @click="isMinimizedCajAi = !isMinimizedCajAi">
                              <template v-if="isMinimizedCajAi">
                                 <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                              </template>
                              <template v-else>
                                 <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                              </template>
                           </w-button>
                        </w-flex>
                     </template>
                  <div v-show="!isMinimizedCajAi">

                     <figure class="table-aims">
                         <figure class="table">
                             <table class="w-table">
                               
                                   <tbody>
                                       <tr>
                                           <td colspan="3"><strong>Tarikh / Perkhidmatan</strong></td>
                                           <td width="1px">:</td>
                                           <td colspan="2">{{$zutil.dateformat(data.tarikh_ai)}}</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td align="right">
                                              <w-tooltip md top color="white" bg-color="black">
                                                <template #activator="{ on }">
                                                   <w-button class="ma1" v-on="on" bg-color="success" @click="cetakCaj(data.id)"><div style="width: 4px"></div> 
                                                      <w-icon class="mr1" md style="color: white;">fal fa-print</w-icon>
                                                   </w-button>
                                                </template>
                                                   Cetak Caj Perkhidmatan
                                               </w-tooltip>
                                            </td>
                                       </tr>
                                       <tr>
                                           <td width="1px"><b>1.</b></td>
                                           <td colspan="2"><strong>Konsultasi / Perkhidmatan</strong></td>
                                           <td>:</td>
                                           <td>
                                                         <w-tag
                                                           class="mr4"
                                                           bg-color="primary"
                                                           round>
                                                            <template v-if="data.konsutasi_ya_tidak==1">Berbayar</template><template v-else>Subsidi</template>
                                                         </w-tag>
                                           </td>
                                           <td align="right">
                                          </td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td colspan="2" align="right">
                                               RM {{$zutil.formatDecimal(data.konsutasi)}}
                                            </td>
                                       </tr>
                                       <tr>
                                           <td><b>2.</b></td>
                                           <td colspan="2"><strong>Harga Embrio</strong></td>
                                           <td colspan="2"><strong>ID Ternakan | No Batch</strong></td>
                                           <td><strong>Harga (RM)</strong></td>
                                           <td>&nbsp;</td>
                                           <td><strong>Kuantiti</strong></td>
                                           <td colspan="2"><strong>Jumlah (RM)</strong></td>
                                       </tr>
                                       <tr>
                                           <td>&nbsp;</td>
                                           <td width="1px" class="text-center">i.</td>
                                           <td>Embrio Subsidi Jabatan (IBVK)</td>
                                           <td colspan="2">
                                                <div v-if="ibvk.length ==0">-</div>
                                                   <div v-for="stock in ibvk" v-else>
                                                   {{stock.no_batch_keterangan}}
                                                </div>
                                           </td>
                                           <td align="right">
                                                <div v-if="ibvk.length ==0">-</div>
                                                   <div v-for="stock in ibvk" v-else>
                                                   {{$zutil.formatDecimal(stock.harga)}}
                                                </div>
                                           </td>
                                           <td>&nbsp;</td>
                                           <td>
                                                <div v-if="ibvk.length ==0">-</div>
                                                   <div v-for="stock in ibvk" v-else>
                                                   {{stock.kuantiti}}
                                                </div>
                                           </td>
                                           <td colspan="2" align="right">
                                                <div v-if="ibvk.length ==0">-</div>
                                                   <div v-for="stock in ibvk" v-else>
                                                   {{$zutil.formatDecimal(stock.total_harga)}}
                                                </div>
                                           </td>
                                       </tr>
                                       <tr>
                                           <td>&nbsp;</td>
                                           <td width="1px" class="text-center">ii.</td>
                                           <td>Embrio Subsidi Jabatan (Negeri)</td>
                                           <td colspan="2">
                                                <div v-if="negri.length ==0">-</div>
                                                   <div v-for="stock in negri" v-else>
                                                   {{stock.no_batch_keterangan}}
                                                </div>
                                           </td>
                                           <td align="right">
                                                <div v-if="negri.length ==0">-</div>
                                                   <div v-for="stock in negri" v-else>
                                                   {{$zutil.formatDecimal(stock.harga)}}
                                                </div>
                                           </td>
                                           <td>&nbsp;</td>
                                           <td>
                                                <div v-if="negri.length ==0">-</div>
                                                   <div v-for="stock in negri" v-else>
                                                   {{stock.kuantiti}}
                                                </div>
                                           </td>
                                           <td align="right" colspan="2">
                                                <div v-if="negri.length ==0">-</div>
                                                   <div v-for="stock in negri" v-else>
                                                   {{$zutil.formatDecimal(stock.total_harga)}}
                                                </div>
                                           </td>
                                       </tr>
                                       <tr>
                                           <td>&nbsp;</td>
                                           <td width="1px" class="text-center">iii.</td>
                                           <td>Embrio Persendirian</td>
                                           <td colspan="2">
                                             <div v-if="persendirian.length ==0">-</div>
                                                      <div v-for="stock in persendirian" v-else>
                                                     {{stock.no_batch_keterangan}}
                                                     </div>
                                             </td>
                                           <td align="right">
                                              <div v-if="persendirian.length ==0">-</div>
                                                   <div v-for="stock in persendirian" v-else>
                                                   {{$zutil.formatDecimal(stock.harga)}}
                                             </div>
                                           </td>
                                           <td>&nbsp;</td>
                                           <td><div v-if="persendirian.length ==0">-</div>
                                                   <div v-for="stock in persendirian" v-else>
                                                   {{stock.kuantiti}}
                                                </div>
                                             </td>
                                           <td align="right" colspan="2">
                                                <div v-if="persendirian.length ==0">-</div>
                                                   <div v-for="stock in persendirian" v-else>
                                                   {{$zutil.formatDecimal(stock.total_harga)}}
                                                </div>
                                           </td>
                                       </tr>
                                       <tr>
                                           <td><b>3.</b></td>
                                           <td colspan="2"><strong>Caj Perjalanan (RM)</strong></td>
                                           <td>:</td>
                                           <td align="left">
                                             <w-tag
                                                class="mr4"
                                                bg-color="primary"
                                                round>
                                                <template v-if="data.bayar_pengangkutan==1">Berbayar</template><template v-else>Subsidi</template>
                                             </w-tag>
                                              
                                           </td>
                                           <td align="right">
                                          </td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td colspan="2" align="right">
                                               RM {{$zutil.formatDecimal(data.pengangkutan)}}
                                            </td>
                                        </tr>
                                        <tr>
                                           <td><b>4.</b></td>
                                           <td colspan="2"><strong>Caj Lain-Lain (Jika Ada)(RM)</strong></td>
                                           <td>:</td>
                                           <td align="left">
                                             <w-tag
                                                class="mr4"
                                                bg-color="primary"
                                                round>
                                                <template v-if="data.bayar_caj_lain==1">Berbayar</template><template v-else>Subsidi</template>
                                             </w-tag>
                                              
                                           </td>
                                           <td align="right">
                                          </td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td colspan="2" align="right">
                                               RM {{$zutil.formatDecimal(data.caj_lain)}}
                                            </td>
                                       </tr>
                                       <tr>
                                           <td>&nbsp;</td>
                                           <td colspan="2">Nyatakan</td>
                                           <td>:</td>
                                           <td><template v-if="data.nyatakan==null">-</template>
                                                <template v-else>{{data.nyatakan}}</template></td>
                                           <td align="right"></td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                       </tr>
                                       <tr>
                                           <td colspan="3">&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                       </tr>
                                       <tr>
                                           <td colspan="3">&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                       </tr>
                                       <tr>
                                           <td colspan="3"><strong>Jumlah Caj Keseluruhan</strong></td>
                                           <td>:</td>
                                           <td colspan="2" align="left">RM {{$zutil.formatDecimal(data.keseluruhan)}}</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                           <td colspan="3"><strong>Jumlah Caj Subsidi Kerajaan</strong></td>
                                           <td>:&nbsp;</td>
                                           <td colspan="2" align="left">RM {{$zutil.formatDecimal(data.subsidi)}}</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                       </tr>
                                       <tr>
                                           <td colspan="3"><strong>Jumlah Caj Yang Perlu Dibayar</strong></td>
                                           <td>:</td>
                                           <td colspan="2" align="left">RM {{$zutil.formatDecimal(data.perlu_bayar)}}</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                       </tr>
                                   </tbody>
                               
                             </table>
                         </figure>
                     </figure>

                  </div>


               </w-card>
               <br>

               <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'CAJ PERKHIDMATAN KEBUNTINGAN ET'" v-if="data.tarikh_pemeriksaan_art != null">
                     <template #title>
                        CAJ PERKHIDMATAN KEBUNTINGAN ET
                        <w-flex justify-end class="mt2">
                           <w-button @click="isMinimizedCajKeb = !isMinimizedCajKeb">
                              <template v-if="isMinimizedCajKeb">
                                 <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                              </template>
                              <template v-else>
                                 <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                              </template>
                           </w-button>
                        </w-flex>
                     </template>
                  <div v-show="!isMinimizedCajKeb">
                     <figure class="table-aims">
                         <figure class="table">
                             <table class="w-table">
                               
                                   <tbody>
                                      <tr>
                                           <td width="1%"></td>
                                           <td width="33%"></td>
                                           <td width="1%"></td>
                                           <td width="20%"></td>
                                           <td width="45%">&nbsp;</td>
                                       </tr>
                                       <tr>
                                           <td colspan="2"><strong>Tarikh / Perkhidmatan</strong></td>
                                           <td width="1px">:</td>
                                           <td >{{$zutil.dateformat(data.tarikh_pemeriksaan_art)}}</td>
                                           <td>&nbsp;</td>
                                       </tr>
                                       <tr>
                                           <td width="1px"><b>1.</b></td>
                                           <td ><strong>Konsultasi / Perkhidmatan</strong></td>
                                           <td>:</td>
                                           <td >
                                                         <w-tag
                                                           class="mr4"
                                                           bg-color="primary"
                                                           round>
                                                            <template v-if="data.konsutasi_pemeriksaan_ya_tidak==1">Berbayar</template><template v-else>Subsidi</template>
                                                         </w-tag>
                                                        RM {{$zutil.formatDecimal(data.konsutasi_pemeriksaan)}}</td>
                                           <td>&nbsp;</td>
                                       </tr>                                       
                                       <tr>
                                           <td><b>2.</b></td>
                                           <td ><strong>Caj Pemeriksaan PD (RM)</strong></td>
                                           <td>:</td>
                                           <td align="left"> 
                                                    <w-tag
                                                           class="mr4"
                                                           bg-color="primary"
                                                           round>
                                                            <template v-if="data.bayar_pemeriksaan_pd==1">Berbayar</template><template v-else>Subsidi</template>
                                                         </w-tag>
                                           RM {{$zutil.formatDecimal(data.caj_pemeriksaan_pd)}}</td>
                                           <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                           <td><b>3.</b></td>
                                           <td ><strong>Caj Perjalanan (RM)</strong></td>
                                           <td>:</td>
                                           <td align="left">
                                                         <w-tag
                                                           class="mr4"
                                                           bg-color="primary"
                                                           round>
                                                            <template v-if="data.bayar_pengangkutan_pemeriksaan==1">Berbayar</template><template v-else>Subsidi</template>
                                                         </w-tag>
                                               RM {{$zutil.formatDecimal(data.pengangkutan_pemeriksaan)}}
                                           </td>
                                           <td>&nbsp;</td>
                                       </tr>
                                       <tr>
                                           <td><b>4.</b></td>
                                           <td ><strong>Caj Lain-Lain (Jika Ada) (RM)</strong></td>
                                           <td>:</td>
                                           <td  align="left">
                                                         <w-tag
                                                           class="mr4"
                                                           bg-color="primary"
                                                           round>
                                                            <template v-if="data.bayar_caj_lain_pemeriksaan==1">Berbayar</template><template v-else>Subsidi</template>
                                                         </w-tag>
                                              RM {{$zutil.formatDecimal(data.caj_lain_pemeriksaan)}}
                                           </td>
                                           <td>&nbsp;</td>
                                       </tr>
                                       <tr>
                                           <td>&nbsp;</td>
                                           <td >Nyatakan</td>
                                           <td>:</td>
                                           <td><template v-if="data.nyatakan_pemeriksaan==null">-</template>
                                                <template v-else>{{data.nyatakan_pemeriksaan}}</template></td>
                                           <td>&nbsp;</td>
                                       </tr>
                                       <tr>
                                           <td colspan="5">&nbsp;</td>
                                       </tr>
                                       <tr>
                                           <td colspan="2"><strong>Jumlah Caj Keseluruhan</strong></td>
                                           <td>:</td>
                                           <td align="left">RM {{$zutil.formatDecimal(data.keseluruhan_pemeriksaan)}}</td>
                                           <td>&nbsp;</td>
                                        </tr>
                                       <tr>
                                           <td colspan="2"><strong>Jumlah Caj Yang Perlu Dibayar</strong></td>
                                           <td>:</td>
                                           <td align="left">RM {{$zutil.formatDecimal(data.perlu_bayar_pemeriksaan)}}</td>
                                           <td>&nbsp;</td>
                                       </tr>
                                        <tr>
                                           <td colspan="2"><strong>Jumlah Caj Subsidi Kerajaan</strong></td>
                                           <td>:&nbsp;</td>
                                           <td align="left">RM {{$zutil.formatDecimal(data.subsidi_pemeriksaan)}}</td>
                                           <td>&nbsp;</td>
                                       </tr>
                                   </tbody>
                              
                             </table>
                         </figure>
                     </figure>
                  </div>
               </w-card>
               <br>
               <w-flex justify-end class="mt2">
                  <!-- semakan perakuan 1 -->
                  <template v-if="data.lkp_status_id==35 && data.tarikh_pemeriksaan_art == null">
                     <w-button class="mr2" bg-color="success" @click="sahkan(39)">
                        <w-icon m class="mr2">fal fa-check-circle</w-icon>SAHKAN
                     </w-button>
                     <br>
                     <w-button class="mr2" bg-color="error" @click="semaksemula(27)">
                        <w-icon m class="mr2">fal fa-times-circle</w-icon>SEMAK SEMULA
                     </w-button>
                  </template>
                  <!-- semakan perakuan 2 -->
                  <template v-else-if="data.lkp_status_id==35 && data.tarikh_pemeriksaan_art != null && ada_bunting ==1">
                     <w-button class="mr2" bg-color="success" @click="sahkan(40)">
                        <w-icon m class="mr2">fal fa-check-circle</w-icon>SAHKAN
                     </w-button>
                     <br>
                     <w-button class="mr2" bg-color="error" @click="semaksemula(27)">
                        <w-icon m class="mr2">fal fa-times-circle</w-icon>SEMAK SEMULA
                     </w-button>
                  </template>
                  <!-- mohon pd -->
                  <template v-else-if="data.lkp_status_id==39 && data.juruteknik_pd_id==0">
                     <w-button class="mr2" bg-color="primary" @click="mohonPd(40)">
                        <w-icon m class="mr2">fal fa-paper-plane</w-icon>Mohon PD
                     </w-button>
                  </template>
                  <!-- <template v-else-if="data.lkp_status_id==35 && data.tarikh_pemeriksaan_art != null && ada_bunting ==0">
                     <w-button class="mr2" bg-color="success" @click="sahkan(18)">
                        <w-icon m class="mr2">fal fa-check-circle</w-icon>SELESAI
                     </w-button>
                  </template> -->
               </w-flex>
               <br>
            </template>
            <template #item-content.2>
               <ButiranKelahiran :d_data="data" :d_segmenName="segmenName" v-if="data.id > 0"/>
            </template>
            <template #item-content.3>
               <w-card title-class="blue-dark4--bg white" style="font-size: 13px;"  :title="'AUDIT TRAIL'" >
                  <div class="w-table-wrap" style="max-height: 400px;">
                     <div class="table-profil-scrol">
                        <table class="w-table" color="light" >
                           <thead>
                              <tr>
                                <th class="w-table__header  text-center" width="1%">BIL</th>
                                <th class="w-table__header  text-center">NAMA</th>
                                <th class="w-table__header  text-center">STATUS</th>
                                <th class="w-table__header  text-center">CATATAN</th>
                                <th class="w-table__header  text-center">TARIKH</th>      
                              </tr>
                           </thead>
                           <tbody>
                              <template v-for="(data, ind) in data.audit_trail">
                              <tr class="w-table__row" >
                                  <td class="w-table__cell text-center" >{{ind+1}}</td>
                                  <td class="w-table__cell text-center" >{{data.user}}</td>
                                  <td class="w-table__cell text-center" >{{data.status}}</td>
                                  <td class="w-table__cell text-center" >{{data.remark}}</td>
                                  <td class="w-table__cell text-center" >{{data.tarikh}}</td>
                                 </tr>
                              </template>
                           </tbody>
                        </table>
                     </div>
                  </div>
               </w-card>
            </template>
         </w-tabs>
         <w-dialog
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            :width="dialog.width"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-dark1--bg white">
            <template #title>
               <w-icon class="mr2">fal fa-list</w-icon>
               {{dialog.item.ternakan_nama}}
            </template>
            <template v-if="dialog.tab == 0">
               <w-tabs :items="tabsModal" card v-model="activeTabModal">
                  <template #item-content.1>
                     <div class="w-flex wrap smd-column" >
                        <div class="grow " style="line-height: 35px">
                           <table >
                              <tbody>
                              <tr class="row_data">
                                 <td><b>Status Kesihatan</b></td>  
                                 <td>:</td>
                                 <td>{{dialog.item.lkp_status_kesihatan}}</td>
                              </tr>
                              <tr class="row_data">
                                 <td><b>Skor Badan</b></td>  
                                 <td>:</td>
                                 <td>{{dialog.item.skor_badan}}</td>
                              </tr>
                              <tr class="row_data">
                                 <td><b>Tarikh Sinkronisasi</b></td>  
                                 <td>:</td>
                                 <td>{{$zutil.dateformat(dialog.item.tarikh_sinkronisasi)}}</td>
                              </tr>
                              <tr class="row_data">
                                 <td><b>Tarikh Biang</b></td>  
                                 <td>:</td>
                                 <td>{{$zutil.dateformat(dialog.item.tarikh_biang)}}</td>
                              </tr>
                              <tr class="row_data">
                                 <td><b>Pemeriksaan Organ Reproduksi</b></td>  
                                 <td>:</td>
                                 <td>{{dialog.item.lkp_pemeriksaan_organ}}</td>
                              </tr>
                              <tr class="row_data">
                                 <td><b>Catatan</b></td>  
                                 <td>:</td>
                                 <td>{{dialog.item.catatan}}</td>
                              </tr>
                              <tr class="row_data">
                                 <td><b>Setatus Penilaian</b></td>  
                                 <td>:</td>
                                 <td><template v-if="dialog.item.status_pemeriksaan==1">Lulus</template><template v-else>Tidak Lulus</template></td>
                              </tr>
                              </tbody>
                           </table>
                        </div>
                     </div>
                  </template>
                  <template #item-content.2>

               <div class="w-flex wrap smd-column" >
                  <div class="grow " style="line-height: 35px">
                     <table >
                        <tbody>
                        <tr class="row_data">
                           <td><b>No Kes ET</b></td>  
                           <td>:</td>
                           <td>{{dialog.item.no_kes}}</td>
                        </tr>
                        <tr class="row_data">
                           <td><b>Sumber Embrio</b></td>  
                           <td>:</td>
                           <td>{{dialog.item.lkp_kategori_semen}}</td>
                        </tr>
                        <tr class="row_data">
                           <td><b>No Batch Embrio</b></td>  
                           <td>:</td>
                           <td>
                              <div v-if="!dialog.item.no_batch_keterangan">
                                 {{dialog.item.no_batch}}
                              </div>
                              <div v-else>
                                 {{dialog.item.no_batch_keterangan }}
                              </div>
                           </td>
                        </tr>
                        <tr class="row_data">
                           <td><b>ID Jantan | ID Betina</b></td>  
                           <td>:</td>
                           <td>
                              <div v-if="!dialog.item.no_batch_keterangan">
                                 {{dialog.item.id_ternakan_batch}} | {{dialog.item.id_ternakan_betina}}
                              </div>
                              <div v-else>
                                 {{dialog.item.no_batch_keterangan }}
                              </div>
                           </td>
                        </tr>
                        </tbody>
                     </table>
                  </div>
                  <div class="grow " style="line-height: 35px">
                     <table >
                        <tbody>
                        <tr class="row_data">
                           <td><b>Bil Straw Embrio</b></td>  
                           <td>:</td>
                           <td>{{dialog.item.bil_straw}}</td>
                        </tr>
                        <tr class="row_data">
                           <td><b>Generasi Embrio</b></td>  
                           <td>:</td>
                           <td>{{dialog.item.gred}}</td>
                        </tr>
                        <tr class="row_data">
                           <td><b>Stage Embrio</b></td>  
                           <td>:</td>
                           <td>{{dialog.item.stage}}</td>
                        </tr>
                        <tr class="row_data">
                           <td><b>Harga Embrio Per Straw (RM)</b></td>  
                           <td>:</td>
                           <td>{{$zutil.formatDecimal(dialog.item.harga_straw)}}</td>
                        </tr>
                        <tr class="row_data">
                           <td><b>Tarikh Jangkaan PD</b></td>  
                           <td>:</td>
                           <td>{{$zutil.dateformat(dialog.item.jankaan_biang_semula)}}</td>
                        </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
                  </template>
                  <template #item-content.3>
                     <div class="w-flex wrap smd-column" >
                        <div class="grow " style="line-height: 35px">
                           <table >
                              <tbody>
                              <tr class="row_data">
                                 <td><b>No Kes ET</b></td>  
                                 <td>:</td>
                                 <td>{{dialog.item.no_kes}}</td>
                              </tr>
                              <tr class="row_data">
                                 <td><b>Baka</b></td>  
                                 <td>:</td>
                                 <td>{{dialog.item.baka}}</td>
                              </tr>
                              <tr class="row_data">
                                 <td><b>Tarikh Beranak Terdahulu</b></td>  
                                 <td>:</td>
                                 <td>{{dialog.item.tarikh_beranak_terdahulu}}</td>
                              </tr>
                              <tr class="row_data">
                                 <td><b>Tarikh Suntikan Terdahulu/ Nama Juruteknik/ Jurusuntik</b></td>  
                                 <td>:</td>
                                 <td>-</td>
                              </tr>
                              <tr class="row_data">
                                 <td><b>Kaedah Pemeriksaan</b></td>  
                                 <td>:</td>
                                 <td>{{dialog.item.lkpKaedahPemeriksaan_keterangan}}</td>
                              </tr>
                              <tr class="row_data">
                                 <td><b>Status</b></td>  
                                 <td>:</td>
                                 <td><div v-if="dialog.item.bunting_art==1">Bunting</div><div v-else>Tidak Bunting</div></td>
                              </tr>
                              <tr class="row_data">
                                 <td><b>Usia Kebuntingan</b></td>  
                                 <td>:</td>
                                 <td>{{dialog.item.usia_bunting_art}}</td>
                              </tr>
                              <tr class="row_data">
                                 <td><b>Tarikh Jangkaan Beranak</b></td>  
                                 <td>:</td>
                                 <td>{{$zutil.dateformat(dialog.item.jankaan_kelahiran_art)}}</td>
                              </tr>
                              </tbody>
                           </table>
                        </div>
                     </div> 
                  </template>
               </w-tabs>
            </template>
            <template v-if="dialog.tab == 1">
               <div class="w-flex wrap smd-column" >
                        <div class="grow " style="line-height: 35px">
                           <table >
                              <tbody>
                              <tr class="row_data">
                                 <td><b>Status Kesihatan</b></td>  
                                 <td>:</td>
                                 <td>{{dialog.item.lkp_status_kesihatan}}</td>
                              </tr>
                              <tr class="row_data">
                                 <td><b>Skor Badan</b></td>  
                                 <td>:</td>
                                 <td>{{dialog.item.skor_badan}}</td>
                              </tr>
                              <tr class="row_data">
                                 <td><b>Tarikh Sinkronisasi</b></td>  
                                 <td>:</td>
                                 <td>{{$zutil.dateformat(dialog.item.tarikh_sinkronisasi)}}</td>
                              </tr>
                              <tr class="row_data">
                                 <td><b>Tarikh Biang</b></td>  
                                 <td>:</td>
                                 <td>{{$zutil.dateformat(dialog.item.tarikh_biang)}}</td>
                              </tr>
                              <tr class="row_data">
                                 <td><b>Pemeriksaan Organ Reproduksi</b></td>  
                                 <td>:</td>
                                 <td>{{dialog.item.lkp_pemeriksaan_organ}}</td>
                              </tr>
                              <tr class="row_data">
                                 <td><b>Catatan</b></td>  
                                 <td>:</td>
                                 <td>{{dialog.item.catatan}}</td>
                              </tr>
                              <tr class="row_data">
                                 <td><b>Setatus Penilaian</b></td>  
                                 <td>:</td>
                                 <td><template v-if="dialog.item.status_pemeriksaan==1">Lulus</template><template v-else>Tidak Lulus</template></td>
                              </tr>
                           </tbody>
                           </table>
                        </div>
                     </div>
            </template>
            <template v-if="dialog.tab == 2">
               <div class="w-flex wrap smd-column" >
                  <div class="grow " style="line-height: 35px">
                     <table >
                        <tbody>
                        <tr class="row_data">
                           <td><b>No Kes ET</b></td>  
                           <td>:</td>
                           <td>{{dialog.item.no_kes}}</td>
                        </tr>
                        <tr class="row_data">
                           <td><b>Sumber Embrio</b></td>  
                           <td>:</td>
                           <td>{{dialog.item.lkp_kategori_semen}}</td>
                        </tr>
                        <tr class="row_data">
                           <td><b>No Batch Embrio</b></td>  
                           <td>:</td>
                           <td>
                              <div v-if="!dialog.item.no_batch_keterangan">
                                 {{dialog.item.no_batch}}
                              </div>
                              <div v-else>
                                 {{dialog.item.no_batch_keterangan }}
                              </div>
                           </td>
                        </tr>
                        <tr class="row_data">
                           <td><b>ID Jantan | ID Betina</b></td>  
                           <td>:</td>
                           <td>
                              <div v-if="!dialog.item.no_batch_keterangan">
                                 {{dialog.item.id_ternakan_batch}} | {{dialog.item.id_ternakan_betina}}
                              </div>
                              <div v-else>
                                 {{dialog.item.no_batch_keterangan }}
                              </div>
                           </td>
                        </tr>
                        </tbody>
                     </table>
                  </div>
                  <div class="grow " style="line-height: 35px">
                     <table >
                        <tbody>
                        <tr class="row_data">
                           <td><b>Bil Straw Embrio</b></td>  
                           <td>:</td>
                           <td>{{dialog.item.bil_straw}}</td>
                        </tr>
                        <tr class="row_data">
                           <td><b>Generasi Embrio</b></td>  
                           <td>:</td>
                           <td>{{dialog.item.gred}}</td>
                        </tr>
                        <tr class="row_data">
                           <td><b>Stage Embrio</b></td>  
                           <td>:</td>
                           <td>{{dialog.item.stage}}</td>
                        </tr>
                        <tr class="row_data">
                           <td><b>Harga Embrio Per Straw (RM)</b></td>  
                           <td>:</td>
                           <td>{{$zutil.formatDecimal(dialog.item.harga_straw)}}</td>
                        </tr>
                        <tr class="row_data">
                           <td><b>Tarikh Jangkaan PD</b></td>  
                           <td>:</td>
                           <td>{{$zutil.dateformat(dialog.item.jankaan_biang_semula)}}</td>
                        </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
            </template>
            <template v-if="dialog.tab == 3">
               <div class="w-flex wrap smd-column" >
                  <div class="grow " style="line-height: 35px">
                     <table >
                        <tbody>
                        <tr class="row_data">
                           <td><b>No Kes ET</b></td>  
                           <td>:</td>
                           <td>{{dialog.item.no_kes}}</td>
                        </tr>
                        <tr class="row_data">
                           <td><b>Baka</b></td>  
                           <td>:</td>
                           <td>{{dialog.item.baka}}</td>
                        </tr>
                        <tr class="row_data">
                           <td><b>Tarikh Beranak Terdahulu</b></td>  
                           <td>:</td>
                           <td>{{dialog.item.tarikh_beranak_terdahulu}}</td>
                        </tr>
                        <tr class="row_data">
                           <td><b>Tarikh Suntikan Terdahulu/ Nama Juruteknik/ Jurusuntik</b></td>  
                           <td>:</td>
                           <td>-</td>
                        </tr>
                        <tr class="row_data">
                           <td><b>Kaedah Pemeriksaan</b></td>  
                           <td>:</td>
                           <td>{{dialog.item.lkpKaedahPemeriksaan_keterangan}}</td>
                        </tr>
                        <tr class="row_data">
                           <td><b>Status</b></td>  
                           <td>:</td>
                           <td><div v-if="dialog.item.bunting_art==1">Bunting</div><div v-else>Tidak Bunting</div></td>
                        </tr>
                        <tr class="row_data">
                           <td><b>Usia Kebuntingan</b></td>  
                           <td>:</td>
                           <td>{{dialog.item.usia_bunting_art}}</td>
                        </tr>
                        <tr class="row_data">
                           <td><b>Tarikh Jangkaan Beranak</b></td>  
                           <td>:</td>
                           <td>{{$zutil.dateformat(dialog.item.jankaan_kelahiran_art)}}</td>
                        </tr>
                        </tbody>
                     </table>
                  </div>
               </div> 
            </template>
            <template #actions>
               <div class="spacer" />
                  <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
            </template>
         </w-dialog>
         <w-dialog
            v-model="dialogPd.show"
            :fullscreen="dialogPd.fullscreen"
            :width="dialogPd.width"
            :persistent="dialogPd.persistent"
            :persistent-no-animation="dialogPd.persistentNoAnimation"
            title-class="primary-dark1--bg white">
            <template #title>
               <w-icon class="mr2">fal fa-list</w-icon>
               Mohon PD
            </template>
            <z-select class="mt4"  outline :items="lkp_tujuan" label="Tujuan PD*" v-model="form_pd.lkp_tujuan_id" :validators="[validators.required]" readonly/>
            <z-select class="mt4" outline :items="juruteknik_list" label="Nama Juruteknik/Jurusuntik *"  v-model="form_pd.juruteknik_pd_id"  :validators="[validators.required]"/>
            <br>
            <div class="w-flex wrap smd-column" >
               <div class="grow ">
                  <table >
                     <tbody>
                     <tr class="row_data"><td>
                        <w-input type="date" label="Tarikh Jangkaan PD *" v-model="form_pd.jankaan_biang_semula" outline :validators="[validators.required]" readonly></w-input>
                     </td></tr>
                     </tbody>
                  </table>
               </div>
               <div class="grow ">
                  <table >
                     <tbody>
                     <tr class="row_data">><td>
                        <w-input type="date" label="Tarikh Temujanji PD *" v-model="form_pd.tarikh_datang_pemeriksaan" outline :validators="[validators.required]" ></w-input>
                     </td></tr>
                     </tbody>
                  </table>
               </div>
            </div>
            <template #actions>
               <div class="spacer" />
               <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogPd.show = false">TUTUP</w-button>
               <w-button class="mr2" bg-color="success" @click="hantarMohon(40)">
                  <w-icon m class="mr2">fal fa-paper-plane</w-icon>Mohon PD
               </w-button>
            </template>
         </w-dialog>

         <w-dialog
            v-model="dialogSemak.show"
            :fullscreen="dialogSemak.fullscreen"
            :width="dialogSemak.width"
            :persistent="dialogSemak.persistent"
            :persistent-no-animation="dialogSemak.persistentNoAnimation"
            title-class="primary-dark1--bg white">
            <template #title>
               <w-icon class="mr2">fal fa-list</w-icon>
               Semak Semula Perkhidmatan
            </template>
            <br>{{dialogSemak.form}}
            <w-form 
               ref="form" 
               v-model="dialogSemak.valid"
               @validate="sahkan(27)"
               @success="success"
             >
            <div class="w-flex wrap smd-column" >
                <w-textarea style="margin:5px;" label="Catatan *"  placeholder="Sila masukan.." class="mt4" outline  v-model="dialogSemak.item.catatan" :validators="[validators.required]"/>
            </div>
            </w-form>
            <template #actions>
               <div class="spacer" />
               <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogSemak.show = false">TUTUP</w-button>
               &nbsp;
               <w-button class="mr2" :loading="dialogSemak.loading" :disabled="dialogSemak.loading || dialogSemak.item.catatan == null" @click="sahkan(27)">
                  <w-icon m class="mr2">fal fa-paper-plane</w-icon>Hantar
               </w-button>
            </template>
         </w-dialog>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
// import Ternakan from './Show/Ternakan.vue';
import VueQrcode from 'vue-qrcode'
import ButiranKelahiran from './Sub/ButiranKelahiran.vue'

export default {
  extends: ZResource,
  components: {
    VueQrcode, ButiranKelahiran
  },
  props: {
    d_id: [Array, Object, String],

  },
  data() {
    return {
      resourceurl: 'art.permohonan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pembiakan Permohonan', route: '/art' },
        { label: 'Permohonan', route: '/art/permohonan' },
        { label: 'Papar', route: '/art/permohonan/'+this.id },
      ],

      title : '',
      id:this.d_id,
      data : {id : 0},
      activeTab : 0,
      activeTabModal : 0,
      ada_bunting: 0,
      ternakan_list:[],
      tabs: [
            { title: 'RUMUSAN PERKHIDMATAN', content: '' },
            { title: 'BUTIRAN KELAHIRAN', content: ''},
            { title: 'JEJAK AUDIT', content: ''},//disable dulu
      ],
      tabsModal: [
            { title: 'MAKLUMAT PEMERIKSAAN TERNAKAN', content: '' },
            { title: 'MAKLUMAT PROSEDUR ET', content: ''},
            { title: 'MAKLUMAT PEMERIKSAAN BUNTINGAN ET', content: ''},
      ],
      ibvk: [],
      negri: [],
      persendirian: [],
      isMinimizedList: false,
      isMinimizedCajAi: false,
      isMinimizedCajKeb: false,
      dialog: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 1500,
          tab: 0,
          item: []
        },
      dialogPd: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 900,
          item: []
        },
      dialogSemak: {
         valid: false,
         show: false,
         fullscreen: false,
         persistent: true,
         persistentNoAnimation: false,
         loading: false,
         width: 900,
         item: {
            catatan:null
         }
      },
      juruteknik_list: [],
      lkp_tujuan:[],
      form_pd:{
         art_id: 0,
         lkp_tujuan_id: null,
         juruteknik_pd_id: 0,
         jankaan_biang_semula: null,
         tarikh_datang_pemeriksaan: null,
      },
      jankaan_biang_semula:null,
    }
  },
  methods: {
      semaksemula(){
         this.dialogSemak.show = true;
      },
      validateForm() {
         this.loading=true;
         let isValid = true;
         let jumlah_lulus = 0;
         this.data.ternakan_list.forEach((row) => {
            if (row.pilih == true) {
               jumlah_lulus = 1;
            }
         })

         if (jumlah_lulus == 0) {
           this.$zutil.notify("Pastikan data sudah di Pilih", false);
           this.loading=false;
           return false;
         }

         this.MohonSemula()
      },

      MohonSemula(){
         this.$swal({
             title: 'Anda Pasti?',
             // text: "Are you sure want to delete this item!",
             type: 'warning',
             showCancelButton: true,
             confirmButtonColor: '#3085d6',
             cancelButtonColor: '#d33',
             confirmButtonText: 'Ya',
             cancelButtonText: 'Tidak'
            }).then((result) => {
            if (result.value) {
               if(this.data.id > 0){
               this.$zcomm.update('art.semakan.mohonSemulaAi', this.data.id, this.data)
                 .then(res => {
                     this.$inertia.visit(window.route('art.permohonan.et',0)+'?salin='+this.data.id);
                     this.loading = false;
                 })
                 .catch(err => {

                 })
                 .finally(() => {
                   
                 });
             }
           }else{ this.loading = false;}

           }) 
      },
      mohonPd(dt, tab){
         this.form_pd.art_id = this.data.id;
         this.form_pd.lkp_tujuan_id = 5;
         this.form_pd.jankaan_biang_semula = this.jankaan_biang_semula ;
         this.form_pd.tarikh_datang_pemeriksaan = null; 
         this.dialogPd.show = true;
         this.getJuruteknik();
         this.getTujuanPd();
      },
      getJuruteknik(data){
         this.$zcomm.get(this.api_service + 'lookup/juruteknik/'+this.data.lkp_negeri_id+'/2'+'/0', {}).then(res => {
            this.juruteknik_list = res
         });
      },
      getTujuanPd(){
         this.$zcomm.get(this.api_service + 'lookup/tujuan', {}).then(res => {
           this.lkp_tujuan = res
         })
      },
      hantarMohon(){
         let isValid = true;
         this.loading=true;
         if (!this.form_pd.juruteknik_pd_id || !this.form_pd.tarikh_datang_pemeriksaan) {
           isValid = false;
           this.loading=false;
         }
         if (!isValid) 
         {
           this.$zutil.notify("Pastikan semua data sudah diisi", false);
           this.loading=false;
           return false;
         }
         this.$swal({
             title: 'Anda Pasti?',
             // text: "Are you sure want to delete this item!",
             type: 'warning',
             showCancelButton: true,
             confirmButtonColor: '#3085d6',
             cancelButtonColor: '#d33',
             confirmButtonText: 'Ya',
             cancelButtonText: 'Tidak'
            }).then((result) => {
            if (result.value) {
               if(this.data.id > 0){
               this.$zcomm.update('art.semakan.et.mohonpd', this.data.id, this.form_pd)
                 .then(res => {
                     this.loading = false;
                     this.dialogPd.show = false;
                     this.$inertia.visit(window.route('art.semakan.index'));
                 })
                 .catch(err => {

                 })
                 .finally(() => {
                   
                 });
                 this.dialogPd.loading = false;
             }
           }else{ this.loading = false;}

           }) 
      },
      detail(datas, tab){
         this.dialog.item = datas;
         this.dialog.tab = tab ? tab : 0;
         this.dialog.show = true;
      },
    tutup(){
         this.$inertia.visit(window.route('art.semakan.index'));
       },

    cetak(data){
        // this.$inertia.visit(route("kursus.kursus.peserta.sijil_peserta", dt.peseta_user_id) +"?kursus_id="+dt.id,);
        window.open( window.route('art.permohonan.cetak', data), '_blank');
    },

    cetakCaj(data){
        window.open( window.route('art.cetak_caj', data+'?lkp_art='+3), '_blank');
    },

    sahkan(item) {
         if (item == 27) {
            let isValid = true;
            this.dialogSemak.loading=true;
            if (!this.dialogSemak.item.catatan) {
              isValid = false;
              this.dialogSemak.loading=false;
            }
            if (!isValid) 
            {
              this.$zutil.notify("Catatan Wajib diisi", false);
              this.dialogSemak.loading=false;
              return false;
            }
            this.data.semakan_catatan = this.dialogSemak.item.catatan;
         }
        this.loading = true;
        this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
        if (result.value) {
          if(this.data.id > 0){
            this.data.lkp_status_id = item;
            this.data.peternak = 1;
          this.$zcomm.update('art.semakan.et-aiman.update', this.data.id, this.data)
              .then(res => {
                  this.dialog.show = false;
                  this.$inertia.visit(window.route('art.semakan.index'));
              })
              .catch(err => {

              })
              .finally(() => {
              });
              this.dialog.loading = false;
          }
        }else{ this.loading = false;
               this.dialogSemak.loading=false;
            }

        }) 
      },
      kiraanProsedurAi(){
            for (var b in this.data.ternakan_list){
               if (this.data.ternakan_list[b].se_stock_id!=null) {
                  this.jankaan_biang_semula = this.data.ternakan_list[b].jankaan_biang_semula;
                  break;
               }
            }
            var total_harga = 0;

            let ibvk = [];
            ibvk = this.data.ternakan_list
               .filter((item) => item.lkp_kategori_semen_id === 1)
               .map((item) => ({
                 no_batch_keterangan: item.no_batch_keterangan,
                 kuantiti: item.bil_straw,
                 harga: parseFloat(item.harga_straw),
                 total_harga: parseFloat(item.harga_straw) * item.bil_straw,
            }));

            let negri = [];
            negri = this.data.ternakan_list
               .filter((item) => item.lkp_kategori_semen_id === 2)
               .map((item) => ({
                 no_batch_keterangan: item.no_batch_keterangan,
                 kuantiti: item.bil_straw,
                 harga: parseFloat(item.harga_straw),
                 total_harga: parseFloat(item.harga_straw) * item.bil_straw,
            }));

            let persendirian = [];
            persendirian = this.data.ternakan_list
               .filter((item) => item.lkp_kategori_semen_id === 3)
               .map((item) => ({
                  no_batch_keterangan: item.id_ternakan+' | '+item.no_batch,
                 kuantiti: item.bil_straw,
                 harga: parseFloat(item.harga_straw),
                 total_harga: parseFloat(item.harga_straw) * item.bil_straw,
            }));

            const totalIbvk = ibvk.reduce((accumulator, item) => accumulator + item.total_harga, 0);
            const totalNegri = negri.reduce((accumulator, item) => accumulator + item.total_harga, 0);
            const totalPersendirian = persendirian.reduce((accumulator, item) => accumulator + item.total_harga, 0);

          // Output
          console.log('No Batch List:', ibvk);
            var no_batch_keterangan = [];
            for (var b in this.ternakan_list){
              if (this.ternakan_list[b].lkp_kategori_semen_id==1) {
                no_batch_keterangan= this.ternakan_list[b].no_batch_keterangan
              }
            }
            this.ibvk = ibvk;
            this.negri = negri;
            this.persendirian = persendirian;
            this.data.keseluruhan = Number(this.data.pengangkutan) + Number(this.data.konsutasi) + Number(this.data.caj_lain) + Number(totalIbvk) + Number(totalNegri) + Number(totalPersendirian);
            if(this.data.jenis_pengguna_pemohon == 1){
               if(this.data.konsutasi_ya_tidak==2){ 
                  var subsidi = Number(totalIbvk) + Number(totalNegri) + Number(this.data.pengangkutan) + Number(this.data.konsutasi) + Number(this.data.caj_lain);
               }else{
                  var subsidi = Number(totalIbvk) + Number(totalNegri) + Number(this.data.pengangkutan) + Number(this.data.caj_lain);
               }
               this.data.subsidi = subsidi;
               this.data.perlu_bayar = this.data.keseluruhan - subsidi;
            }else{
               if(this.data.konsutasi_ya_tidak==2){ 
                  var subsidi = Number(totalIbvk) + Number(this.data.konsutasi) + Number(totalNegri);
                  // var perlu_bayar = Number(totalPersendirian) + Number(this.datas.caj_lain)+ Number(this.datas.pengangkutan);
               }else{
                  var subsidi = Number(totalIbvk) + Number(totalNegri);
                  // var perlu_bayar = Number(this.datas.konsutasi) + Number(totalPersendirian) + Number(this.datas.caj_lain)+ Number(this.datas.pengangkutan);
               }
               this.data.subsidi = subsidi;
               this.data.perlu_bayar = this.data.keseluruhan - subsidi ;
            }
         // console.log(datas.perlu_bayar)
       },

      cekKebuntingan(){
         this.ada_bunting = 0;
         for (var b in this.data.ternakan_list) {
               if(this.data.ternakan_list[b].bunting == 1 || this.data.ternakan_list[b].bunting_art == 1){
                  this.ada_bunting = 1;
                  break;
               }else{
                  this.ada_bunting = 0;
              }
         }
      },

      cetak(data){
        // this.$inertia.visit(route("kursus.kursus.peserta.sijil_peserta", dt.peseta_user_id) +"?kursus_id="+dt.id,);
        window.open( window.route('art.cetak_ternakan.cetak', data), '_blank');
    },
  
    getData()
    {
      this.$zcomm.get(this.api_service + 'art/show/'+this.id, {}).then(res => {
        this.data = res

         this.kiraanProsedurAi();
         this.cekKebuntingan();
        // if (this.data) {}
      // if(this.$zutil.role('1')){
      //     this.tabs = [
      //       // { title: 'Baka', content: '' },
      //       { title: 'Ternakan', content: '' },
            
      //     ]
      //   }
      //   else
      //   {
      //     this.tabs = [
      //       { title: 'Ternakan', content: '' },
           
      //     ]
      //   }
         // if(this.data.lkp_status_id==40||this.data.lkp_status_id==18){
         //    this.tabs[1].disabled = false;
         // }else{
         //    this.tabs[1].disabled = true;
         // }
       if(this.data.lkp_art_id == 1)
        {
          this.title = 'RUMUSAN PERKHIDMATAN AI'
        }
        if(this.data.lkp_art_id == 2)
        {
          this.title = 'RUMUSAN PEMERIKSAAN KEBUNTINGAN'
        }
        if(this.data.lkp_art_id == 3)
        {
          this.title = 'RUMUSAN PERKHIDMATAN ET'
        }
        this.params = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
      if(this.params.t == 2){
        this.activeTab = 1
      }

      })
    },

    
   

  },
  watch: {

  },
  mounted() {
    this.getData();

    
    
  },
}
</script>

<style>
.table-aims td{
   padding: 7px;
}
</style>

